import {Order} from "../../../../graphics/tables/operations/sort";
import {ApiDatasource} from "../../adapters/io/datasources/ApiDatasource";
import {unwrap} from "../../adapters/io/network/HttpResponse";
import {formatText} from "../../adapters/io/network/utils";
import {ApiDatasourceSpec} from "../../core/datasource";
import {AuthState} from "@okta/okta-auth-js";
import {buildHeader} from "./utils/Utils";
import {TransferTransporterByCountryTableStructure} from "../indexes/TransferTransporterByCountryIndexes";

export const searchTransferTransporterByCountry = <T>(
    authState: AuthState,
    search: TransferTransporterByCountryTableStructure.FormattedSearchValue[],
    page?: number,
    limit?: number,
    order?: Order,
    orderBy?: string | number,
    datasource: ApiDatasourceSpec = new ApiDatasource(),
    uriFormatter: (uri: string, ...params: unknown[]) => string = formatText
): Promise<TransferTransporterByCountryTableStructure.ResponseOf<T>> => {
    const params = new Map();
    page !== undefined && params.set("page", page);
    limit !== undefined && params.set("limit", limit);
    order !== undefined && params.set("order", order);
    orderBy !== undefined && params.set("orderBy", orderBy);

    return datasource.remote
        .postData<
            TransferTransporterByCountryTableStructure.ResponseOf<T>,
            TransferTransporterByCountryTableStructure.ListOfFormattedSearchValue
        >(
            uriFormatter(EndpointTransferTransporterByCountry.endPoint.concat(EndpointTransferTransporterByCountry.search), {}),
            {fieldSearches: search},
            buildHeader(authState),
            params
        )
        .then(unwrap);
};

export const getTransferTransporterByCountryColumnInformation = <T>(
    authState: AuthState,
    datasource: ApiDatasourceSpec = new ApiDatasource(),
    uriFormatter: (uri: string, ...params: unknown[]) => string = formatText
): Promise<TransferTransporterByCountryTableStructure.ResponseOfColumn<T>> => {
    return datasource.remote
        .getData<TransferTransporterByCountryTableStructure.ResponseOfColumn<T>>(
            uriFormatter(EndpointTransferTransporterByCountry.endPoint.concat(EndpointTransferTransporterByCountry.columnInformation), {}),
            buildHeader(authState),
            new Map()
        )
        .then(unwrap);
};

export const upsertTransferTransporterByCountry = <RecordType>(
    authState: AuthState,
    record: RecordType,
    datasource: ApiDatasourceSpec = new ApiDatasource(),
    uriFormatter: (uri: string, ...params: unknown[]) => string = formatText
): Promise<void> => datasource.remote
    .postData<void, RecordType>(
        uriFormatter(EndpointTransferTransporterByCountry.endPoint.concat(EndpointTransferTransporterByCountry.upsert), {}),
        record,
        buildHeader(authState),
        new Map()
    )
    .then(() => {});

export const deleteTransferTransporterByCountry = (
    authState: AuthState,
    id: string,
    datasource: ApiDatasourceSpec = new ApiDatasource(),
    uriFormatter: (uri: string, ...params: unknown[]) => string = formatText
): Promise<void> => datasource.remote
    .deleteData(
        uriFormatter(EndpointTransferTransporterByCountry.endPoint.concat(EndpointTransferTransporterByCountry.delete), {}) + `?id=${id}`,
        buildHeader(authState),
        new Map()
    )
    .then(() => {});

export const EndpointTransferTransporterByCountry = {
    endPoint: "/end-point/transfer-transporter-by-country",
    columnInformation: "/column-information",
    search: "/search",
    upsert: "/upsert",
    delete: ""
};
